import toast from "react-hot-toast";
import { findObjectUseCase, upsertUseCase } from "../../usecases/object";
import { signOutUseCase } from "../../usecases/user";

class SignInPresenter {
  constructor(view, signInUseCase, findObjectUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    try {
      const masterKey = this.view.getMasterKey();
      const requesttedUser = {
        ...this.change,
        email: this.change.username,
        masterKey,
      };
      this.view.showProgress();

      console.log(" { username: this.change.username }", {
        username: this.change.username,
      });

      const [checkUser] = await findObjectUseCase().execute(
        "users",
        {
          where: { username: this.change.username },
        },
        { session: "7c2e91b4-3f5d-4a87-b16e-d94a0c5f2e13" },
      );

      console.log("check", checkUser);

      if (checkUser?.status === "Inactive") {
        this.view.hideProgress();
        toast.error("This account is currently inactive.", {
          position: "top-right",
        });

        setTimeout(() => {
          window.location.reload();
        }, 3000);
        return;
      }

      if (checkUser?.registrationStatus === "Pending") {
        this.view.hideProgress();
        toast.error(
          "This account's registration status is currently pending.",
          {
            position: "top-right",
          },
        );

        setTimeout(() => {
          window.location.reload();
        }, 3000);
        return;
      }

      console.log("before delete", checkUser);

      if (checkUser?.is_Delete === true) {
        this.view.hideProgress();

        // toast.error("This account was removed.", {
        //   position: "top-right",
        // });

        toast.error(
          "Your account has been deactivated. Please contact your administrator.",
          {
            position: "top-right",
          },
        );

        setTimeout(() => {
          window.location.reload();
        }, 3000);

        return;
      }

      const user = await this.signInUseCase.execute(requesttedUser);

      const payload_logs = {
        user: { id: user.id },
        username: user?.username,
        login_at: new Date().toISOString(),
        login_status: "Success",
      };

      const user_payload = {
        id: user.id,
        last_login_at: new Date().toISOString(),
      };

      await upsertUseCase().execute("user_login_logs", payload_logs);
      await upsertUseCase().execute("users", user_payload);

      if (user.roles.some((role) => role.id === "admin")) {
        this.view.navigateTo("/user/affiliates");
      } else {
        this.view.navigateTo("/user/negative-records");
      }
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }
}

export default SignInPresenter;
